import React, { Component } from 'react';
import Once from '../core/Once';
import ParameterError from '../errors/ParameterError';
export default class MenuManager extends Component {o
	constructor(props){
		super(props);
		const {outerElementRef}=props;
		this._outerElementRef = outerElementRef;
		const seenMenuTypes =[];
		this._currentMenusShowing= [];
		this._mapMenuTypeToMenu = new Map();
		this._menuHistory = [];
		this.showMenuByType = this.showMenuByType.bind(this);
		this._showMenuByType = this._showMenuByType.bind(this);
		this._showMenuWithLoopBreak = this._showMenuWithLoopBreak.bind(this);
		this._showMenu=this._showMenu.bind(this);
		this.close = this.close.bind(this);
		this._close = this._close.bind(this);
		this.showMe= this.showMe.bind(this);
		this.back = this.back.bind(this);
		this._closeOnce = new Once(this._close);
		this._showMenuOnce = new Once(this._showMenu);
		this.state ={hasBacks:false};
	}
	get showing(){
		return this._showing;
	}
	back(){
		if(this._menuHistory.length<2){
			this.close(true);
			return;
		}
		this.showMe(this._menuHistory.splice(this._menuHistory.length-2, 2)[0]);
	}
	close(keepHistory){
		this._closeOnce.trigger(keepHistory);
	}
	_close(keepHistory){
		this._currentMenusShowing.forEach((currentMenuShowing)=>currentMenuShowing.hide());
		this._currentMenusShowing=[];
		if(!keepHistory){
			this._menuHistory=[];
			this._setHasBacks(false);
		}
	}
	_setHasBacks(value){
		const classList = this._outerElementRef?.current?.classList;
		if(!classList)return;
		if(value)classList.add('back-visible');
		else classList.remove('back-visible');
	}
	showMenuByType(menuType){
		this._showMenuByType(menuType);
	}
	showMe(menu){
		this._showMenuWithLoopBreak(menu);
	}
	_showMenuByType(menuType){
		if(!this._mapMenuTypeToMenu.has(menuType))
			throw new Error(`Has no child of menuType "${menuType}"`);
		const menu = this._mapMenuTypeToMenu.get(menuType).ref.current;
		this._showMenuWithLoopBreak(menu);
	}
	_showMenuWithLoopBreak(menu){
		this._showing = menu;
		this._showMenuOnce.trigger(menu);
	}
	_showMenu(menu){
		if(this._currentMenusShowing.length>0)
			this.close(true);
		menu.show();
		this._currentMenusShowing.push(menu);	
		if(this._menuHistory.length<1){
			this._setHasBacks(false);
			this._menuHistory.push(menu);
			return;
		}
		const sameAsLast = this._menuHistory[this._menuHistory.length-1]===menu;
		if(!sameAsLast){
			this._menuHistory.push(menu);
		}
		this._setHasBacks(!sameAsLast);
	}
	componentDidMount() {		
		let index=0;
		this.props.children.forEach((childMenu)=>{
			const menuType = childMenu.ref.current.menuType;
			if(childMenu.ref===null)
				throw new Error(`Child menu at index ${index} with type ${childMenu.type.name} had no ref`);
			if(menuType===undefined||menuType===null)
				throw new Error(`Child menu with type ${childMenu.type.name} had no menuType property`);
			this._mapMenuTypeToMenu.set(menuType, childMenu);
			index++;
			const childMenuInstance = childMenu.ref.current;
			const setIMenuManager=childMenuInstance.setIMenuManager;
			if(setIMenuManager===undefined||setIMenuManager===null)
				throw new Error(`Child menu with type ${childMenu.type.name} had no setIMenuManager method`);
			childMenuInstance.setIMenuManager(this);
		 });
	}
	render() {
		const className = 'menu-manager '+(this.state.hasBacks?"back-visible":"");
		return this.props.children;
	}
}